@if (showLoader) {
  <div>
    <div class="loader" [id]="ref" [ngClass]="{ root: ref === 'root' }">
      <div class="line-spinner"></div>
    </div>
    <!-- <img class="loading" src="./../../../assets/images/ring.gif" width="90"> -->
  </div>
}
